// extracted by mini-css-extract-plugin
module.exports = {"paymentCheckout":"confirm_paymentCheckout__vjbye","viewCart":"confirm_viewCart__wzDuh","method":"confirm_method__2WkTG","addName":"confirm_addName__vNa96"};